import React from "react";

const Paternity = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M11.688 16.064a7.032 7.032 0 100-14.064 7.032 7.032 0 000 14.064zM18.74 16.066a14.526 14.526 0 00-9.698 3.693 3.798 3.798 0 00-3.23-1.794A3.813 3.813 0 002 21.775a3.814 3.814 0 003.074 3.741 14.657 14.657 0 00-.933 5.149v.5c0 .275.233.456.471.456h8.266c.261 0 .475-.114.475-.376s-.475-.576-.475-.576v-.005h-.01l-2.465-1.541a3.332 3.332 0 01-1.061-4.598 3.33 3.33 0 014.597-1.06l6.29 3.926a3.696 3.696 0 00-.656-.062 3.334 3.334 0 00-3.337 3.335A3.337 3.337 0 0019.573 34h11.443a2.32 2.32 0 002.323-2.322v-1.014c0-8.06-6.539-14.598-14.6-14.598zM5.81 24.636a2.859 2.859 0 112.523-4.202c.214.4.338.857.338 1.342a2.867 2.867 0 01-2.86 2.86z"
            fill={fill}
        />
    </svg>
);

export default Paternity;